import React, { Fragment, useEffect, useState } from 'react'
import ReactModal from 'react-modal'
import axios from 'axios'
import { BrowserRouter as Router, Route, Link, Routes } from 'react-router-dom';
import Cookies from 'universal-cookie';
import Swal from 'sweetalert2';
import { creaReporte } from '../../Services/Rest';
//impoertacion componentes

function CrearReportes() {
    const cookie = new Cookies();
    const [modalIsOpen, setIsOpen] = useState(false);
    const handleOpenModalTest = () => {
        setIsOpen(true);
    };
    const closeModal = () => {
        setIsOpen(false);
    };

    const [postNombre, setPostNombre] = useState([]);
    const [postUrl, setPostUrl] = useState([]);
    
    const postData = e => {
        e.preventDefault(e)
        axios({
            auth: { username: 'webapp', password: '762tsfsy9826kk87ytttsf' },
            method: 'post',
            url: creaReporte,
            data: {
                nombre: postNombre,
                url: postUrl,

            }
        })
            .then((Response) => {
                Swal.fire({
                    title: Response.data,
                    text: "Haga clic para continuar",
                    icon: 'success',
                }).then(function () {
                    window.location.reload("/");
                })

            }).catch((error) => {
                Swal.fire({
                    title: "Error",
                    text: "No se pudo crear",
                    icon: 'error',
                }).then(function () {
                    window.location.reload("/");
                })
            })
    };
    return (
        <div className="test">
            <button variant="contained" className='btn btn-primary' color="primary" onClick={handleOpenModalTest} > Nuevo Reporte</button>
            <ReactModal
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                contentLabel="Crear ">

                <div className="container">
                    <div className="text-center">
                        <div class="container-fluid">
                            <div class="card shadow mb-4">
                                <div class="card-header py-3">
                                    <h6 class="m-0 font-weight-bold text-primary">Crear Reporte</h6>
                                </div>
                                <div class="card-body">
                                    <div class="table-responsive"></div>
                                    <form className="user">
                                        <div className="form-group row">
                                            <div className="col-sm-6">
                                                <input type="text" className="form-control form-control-user" placeholder="Nombre" onChange={(e) => setPostNombre(e.target.value)} />
                                            </div>

                                            <div className="col-sm-6">
                                                <input type="text" className="form-control form-control-user" placeholder="Url" onChange={(e) => setPostUrl(e.target.value)} />
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                         


                                        </div>



                                        <a ><button className="btn btn-primary btn-user btn-block" type='submit' onClick={postData}>Guardar</button></a>
                                        <hr className="sidebar-divider" />
                                        <button className="btn btn-secondary" onClick={closeModal}>Volver</button>
                                        <hr />
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ReactModal>

        </div>
    )
}
export default CrearReportes;
